import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createDeviceFailed,
  createDeviceRequested,
  createDeviceSucceeded,
  deleteDeviceFailed,
  deleteDeviceRequested,
  deleteDeviceSucceeded,
  fetchDeviceFailed,
  fetchDeviceRequested,
  fetchDeviceSucceeded,
  updateDeviceFailed,
  updateDeviceRequested,
  updateDeviceSucceeded,
  updateDeviceCommonFailed,
  updateDeviceCommonRequested,
  updateDeviceCommonSucceeded,
  hideDeviceFailed,
  hideDeviceRequested,
  hideDeviceSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createDeviceRequest(data) {
  yield put(
    createDeviceRequested({
      ...data,
    }),
  );

  try {
    const {
      item,
      included: { deviceMemberships, deviceLabels, alarms, attachments },
    } = yield call(request, api.createDevice, data);

    const action = createDeviceSucceeded(
      item,
      deviceMemberships,
      deviceLabels,
      alarms,
      attachments,
    );
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createDeviceFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchDeviceRequest(id) {
  yield put(fetchDeviceRequested(id));

  try {
    const { item } = yield call(request, api.getDevice, id);

    const action = fetchDeviceSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchDeviceFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateDeviceRequest(id, data) {
  yield put(updateDeviceRequested(id, data));

  try {
    const { item } = yield call(request, api.updateDevice, id, data);

    const action = updateDeviceSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateDeviceFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateDeviceCommonRequest(id, data) {
  yield put(updateDeviceCommonRequested(id, data));

  try {
    const { item } = yield call(request, api.updateDeviceCommon, id, data);

    const action = updateDeviceCommonSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateDeviceCommonFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* hideDeviceRequest(id) {
  yield put(hideDeviceRequested(id));

  try {
    const { item } = yield call(request, api.hideDevice, id);
    const action = hideDeviceSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = hideDeviceFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteDeviceRequest(id) {
  yield put(deleteDeviceRequested(id));

  try {
    const { item } = yield call(request, api.deleteDevice, id);

    const action = deleteDeviceSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteDeviceFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
